<template>
  <component :is="componentTag" />
</template>
<script>
import webTechnicalReport from './web';
import mobileTechnicalReport from './mobile';
export default {
  components: {
    webTechnicalReport,
    mobileTechnicalReport
  },
  data() {
    return {
       isMobile: false,
       componentTag: ''
    };
  },
  created() {
     this.listenObserverWidth(750);
  },
  methods: {
    // 监听可视窗口宽度
    listenObserverWidth(mobileWidth) {
       const resizeObserver = new ResizeObserver(entries => {
          for(let entry of entries) {
             if(entry.contentRect.width <= mobileWidth) {
                this.componentTag = 'mobileTechnicalReport';
             } else {
                this.componentTag = 'webTechnicalReport';
             }
          }
       });
       resizeObserver.observe(document.body);
    }
  },
};
</script>